export const LOGIN_ACTION_START = "LOGIN_ACTION_START";
export const LOGIN_ACTION_FINISH = "LOGIN_ACTION_FINISH";
export const LOGIN_ACTION_ERROR = "LOGIN_ACTION_ERROR";
export const LOGOUT_USER = "LOGOUT_USER";
